import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const PageContainer = ({ children }: Props) => <div>{children}</div>;
